import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Es legal reparar el crédito?',
    answer: 'Absolutamente. La ley FCRA te otorga el derecho de disputar cualquier información que sea inexacta, incompleta o no verificable. Nosotros somos expertos en ejecutar ese derecho por ti.'
  }, {
    question: '¿Cuánto tiempo tarda el proceso?',
    answer: 'Cada caso es único, pero la mayoría de nuestros clientes empiezan a ver cambios significativos en sus reportes en los primeros 45 a 90 días.'
  }, {
    question: '¿Qué pasa si ya lo intenté por mi cuenta?',
    answer: 'El sistema está diseñado para ser difícil. Nosotros usamos estrategias de nivel profesional que los burós de crédito no pueden ignorar fácilmente.'
  }];
  return <section className="py-24 lg:py-32 bg-brand-light" data-id="element-43">
      <div className="max-w-3xl mx-auto px-6" data-id="element-44">
        <FadeIn data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-46">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-47">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-48">
              <div className={`bg-white rounded-2xl border transition-colors duration-200 overflow-hidden ${openIndex === index ? 'border-brand-amber/30 shadow-sm' : 'border-slate-200 hover:border-slate-300'}`} data-id="element-49">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left focus:outline-none" data-id="element-50">
                  <span className="font-semibold text-lg text-slate-900 pr-8" data-id="element-51">
                    {faq.question}
                  </span>
                  <ChevronDown className={`flex-shrink-0 text-slate-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-brand-amber' : ''}`} size={24} data-id="element-52" />
                </button>
                <div className={`px-8 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-53">
                  <p className="text-slate-600 leading-relaxed" data-id="element-54">{faq.answer}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}